import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/WorkDirectory.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
